const wrapper = "_35swq53jjm";
const box = "_35sb9m7yrg";
const audio = "_35sa16dlvaz";

export { audio, box, wrapper };
import "./input.text.style.linaria.module.css";
//# sourceMappingURL=input.text.style.js.map
